import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function HowSection() {
  const { t } = useTranslation();

  const steps = [
    { key: 'step1', icon: 'ri-search-line' },
    { key: 'step2', icon: 'ri-scales-3-line' },
    { key: 'step3', icon: 'ri-shield-check-line' },
    { key: 'step4', icon: 'ri-external-link-line' },
  ];

  return (
    <section className="bg-cream">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-stone-900 md:text-3xl">
            {t('how.title')}
          </h2>
          <p className="mt-3 text-sm text-stone-500 md:text-base">{t('how.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, i) => (
            <div key={step.key} className="rounded-lg border border-stone-200 bg-white p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-emerald-50 text-xl text-emerald-600">
                  <i className={step.icon}></i>
                </span>
                <span className="font-heading text-sm font-bold text-stone-300">0{i + 1}</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-stone-900">
                {t(`how.${step.key}.title`)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-stone-500">
                {t(`how.${step.key}.body`)}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-emerald-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-emerald-700"
          >
            {t('how.cta')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}